<template lang="pug">
    div.col-md-10.col-sm-12(style="margin:0 auto")
        form-insert(:IsShowModal.sync="IsShowModalInsert",:nameModulo="nameModulo",:parameter.sync="parameterInsert", @sendInfo="val => Insert(val)")
        form-update(:IsShowModal.sync="IsShowModalUpdate",:nameModulo="nameModulo",:parameter.sync="parameterUpdate", @sendInfo="val => Update(val)")
        .card
            .card-header.bg-menu.text-white
                .card-title
                    .form-row
                        .col-md-9.col-sm-12
                            h4 Mantenedor {{nameModulo}}
                        .col-md-3.col-sm-12.text-right
                            button.btn.btn-sm.btn-primary.text-light(@click="IsShowModalInsert=true") Crear {{nameModulo}} 
                                i.fa.fa-plus-circle
            form-view(:parameter.sync="parameterView",:tablaInfo.sync="tableInfo", @sendSearch="val => List_Info(val)", @sendInfo="val => {IsShowModalUpdate=true,parameterUpdate=val}" ) 

</template>
<script> 
import apiWeb from "../../api/apiSLC.js"
import model from "../../models/enterprise.js"
import formInsert from './components/insert.vue'
import formUpdate from './components/update.vue'
import formView from './components/view.vue'
export default {
    components:{
                formInsert,
                formUpdate,
                formView
    },
    data(){
        return{
                nameModulo:'Empresa',
                pathApi:'Enterprise/Enterprise',
                IsShowModalInsert:false,
                IsShowModalUpdate:false,
                parameterUpdate:Object.assign({}, model.parameterUpdate),
                parameterInsert:Object.assign({}, model.parameterInsert),
                parameterView:Object.assign({}, model.parameterView),
                tableInfo:[]
        }
    },
    mounted(){
        this.List_Info()
    },
    methods:{
        List_Info(){
            apiWeb.post(this.pathApi + "_View",this.parameterView)
                    .then(result=>{
                                if(result.status==0)
                                    this.tableInfo=JSON.parse(result.value)
                                else{
                                    this.$msgbox.show(result.message,"Error nivel 1")
                                }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Insert(){
            this.parameterInsert.User=this.$info.email
            this.parameterInsert.IP=this.$info.ip
            apiWeb.post(this.pathApi + "_Insert",this.parameterInsert)
                    .then(result=>{ 
                            if(result.status==0){
                                this.List_Info()
                                this.IsShowModalInsert=false
                                this.parameterInsert=Object.assign({}, model.parameterInsert)
                                this.$msgbox.show("Ingresado","Notificacion")
                            }
                            else{
                                this.$msgbox.show(result.message,"Error nivel 1")
                            }

                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        },
        Update(){
            this.parameterUpdate.User=this.$info.email
            this.parameterUpdate.IP=this.$info.ip
            apiWeb.post(this.pathApi + "_Update",this.parameterUpdate)
                    .then(result=>{ 
                             if(result.status==0){
                                this.List_Info()
                                this.IsShowModalUpdate=false
                                this.$msgbox.show("Actualizado","Notificacion")
                            }
                            else{
                                this.$msgbox.show(result.message,"Error nivel 1")
                            }
                    })
                    .catch(ex=>{this.$msgbox.show(ex.message,"Error nivel 2")})
        }
    }
}
</script>